import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ["mqi_instructions", "question", "single_question", "note", "question_up", "question_down", "single_question_up", "single_question_down", "note_up", "note_down"];

  connect () { }

  disconnect () { }

  toggleInstructionVisibility (event) {
    // console.log('toggleInstructionVisibility called');
    event.preventDefault();

    const mqi_instructions = document.querySelectorAll('.mqi_instruction');
    mqi_instructions.forEach(instruction => {
      instruction.classList.add('hidden');
    });

    // Get the data-question attribute
    const question = event.currentTarget.getAttribute("data-question");
    console.log('Question:', question);

    // Show the specific instruction
    const instructionElement = document.getElementById('ins_' + question);
    console.log('Instruction Element:', instructionElement);
    if (instructionElement) {
      instructionElement.classList.remove('hidden');
    }
    
  }

    closeInstruction (event) {
    // console.log('closeInstructionVisibility called');
    event.preventDefault();

    const mqi_instructions = document.querySelectorAll('.mqi_instruction');
    mqi_instructions.forEach(instruction => {
      instruction.classList.add('hidden');
    });
    
  }

  toggleQuestionsVisibility () {
    // console.log('toggleQuestionsVisibility called');
    const questions = this.questionTargets;
    questions.forEach(question => question.classList.toggle('hidden'));
    const questionUp = this.question_upTarget;
    const questionDown = this.question_downTarget;
    questionUp.classList.toggle('hidden');
    questionDown.classList.toggle('hidden');
  }

  toggleSingleQuestionsVisibility (event) {
    
    // Find the closest parent with the "question_header" class
    const questionHeader = event.target.closest('.question_header');
    
    // Toggle the up and down chevrons within this specific question
    const singleQuestionUp = questionHeader.querySelector('[data-toggle-target="single_question_up"]');
    const singleQuestionDown = questionHeader.querySelector('[data-toggle-target="single_question_down"]');
    
    singleQuestionUp.classList.toggle('hidden');
    singleQuestionDown.classList.toggle('hidden');
    
    // Toggle the question's content visibility
    const questionGroup = questionHeader.closest('.question');
    const questionTogglable = questionGroup.querySelector('.question_togglable');
    questionTogglable.classList.toggle('hidden');
  }

  toggleNotesVisibility () {
    // console.log('toggleNotesVisibility called');
    const notes = this.noteTargets;
    notes.forEach(note => note.classList.toggle('hidden'));
    const noteUp = this.note_upTarget;
    const noteDown = this.note_downTarget;
    noteUp.classList.toggle('hidden');
    noteDown.classList.toggle('hidden');
  }

}
